<div class="modal-header">
  <h3 class="modal-title">Selecione o período:</h3>
</div>
<div class="modal-body modal-date">
  <uib-datepicker ng-model="pickerModel"
                  ng-change="onDateSelected()"
                  datepicker-options="datePickerOptions"
                  ng-required="true"
                  range-hover>
  </uib-datepicker>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" ng-click="closePeriodSelection()">
    Finalizar a seleção do período
  </button>
</div>
